import VueI18nPhraseInContextEditor from 'vue-i18n-phrase-in-context-editor';

const inContextEditor = ref();

export const useInContextEditor = () => {
  const { $i18n, $config } = useNuxtApp();
  const route = useRoute();
  const { editorEnabled = false, projectId, accountId } = $config.public.phrase;

  const phraseEnabled = route.query.phrase !== undefined && editorEnabled;

  const isPhraseEnabled = () => {
    return inContextEditor.value || phraseEnabled;
  };

  const interpolate = (s: string | number) => {
    return ($i18n as unknown as Vue['$i18n'])
      ?.formatter?.interpolate('', undefined, s.toString())?.join('');
  };

  const usePhraseI18n = (intl: { t: (...args: TFuncParams[]) => unknown }) => {
    return {
      ...intl,
      t: (...args: TFuncParams[]) =>
        isPhraseEnabled()
          ? interpolate(args[0] as unknown as string | number)
          : intl.t(...args),
    };
  };
  const init = () => {
    if (!isPhraseEnabled()) {
      return;
    }

    inContextEditor.value = new VueI18nPhraseInContextEditor($i18n, {
      phraseEnabled,
      autoLowercase: false,
      projectId,
      accountId,
    });
  };

  return {
    usePhraseI18n,
    init,
  };
};
